import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=2cd40e51&scoped=true&"
import script from "./tv.vue?vue&type=script&lang=js&"
export * from "./tv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd40e51",
  null
  
)

export default component.exports